import Button from '@mui/material/Button'
import { ComponentProps, useCallback, useEffect } from 'react'
import { useIntl } from 'react-intl'

import { useAuthState } from '@/modules/auth/hooks/useAuthState.ts'
import { LoginFlowStates } from '@/system/form/states.ts'

import messages from './messages.ts'

export const LoginButton = (props: ComponentProps<typeof Button>) => {
  const { onLoginDone } = useAuthState()
  const { formatMessage } = useIntl()
  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      if (e.data === LoginFlowStates.LoginDone) {
        onLoginDone()
      }
      // TODO: Handle error case
    }
    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [onLoginDone])
  const handleLoginClick = useCallback(() => {
    window.open(`/login.html`, 'loginPopup', 'popup')
  }, [])
  return (
    <Button onClick={handleLoginClick} {...props}>
      {formatMessage(messages.login)}
    </Button>
  )
}
